import { render, staticRenderFns } from "./Dlogin.vue?vue&type=template&id=1c0d8382&scoped=true&"
import script from "./Dlogin.vue?vue&type=script&lang=js&"
export * from "./Dlogin.vue?vue&type=script&lang=js&"
import style0 from "./Dlogin.vue?vue&type=style&index=0&id=1c0d8382&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d8382",
  null
  
)

export default component.exports